import type { FC } from 'react';
import {
  AppSocialFeedMultipostIcon,
  AppSocialFeedVideoIcon
} from '@elfsight/icons';

export type BaseMediaType = 'image' | 'link' | 'gallery' | 'video' | 'audio';

type MediaTypesRecord = Record<
  BaseMediaType,
  {
    title: string;
    icon?: FC;
  }
>;

export const mediaTypes: MediaTypesRecord = {
  audio: {
    title: 'Audio'
  },
  image: {
    title: 'Image'
  },
  link: {
    title: 'Share'
  },
  gallery: {
    title: 'Gallery',
    icon: AppSocialFeedMultipostIcon
  },
  video: {
    title: 'Video',
    icon: AppSocialFeedVideoIcon
  }
};
